module.exports = __webpack_public_path__ + "static/media/rsz_optimism.42d83b82.webp";